import { html, LitElement, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import style from './ui-skrillonetap-icon.css?inline';
import '../../ui-inlined-svg/ui-inlined-svg';

const CName = 'ui-skrillonetap-icon';

@customElement(CName)
export class UISkrillonetapIcon extends LitElement {
  static readonly styles = unsafeCSS(style);

  @property({ type: String }) class = '';
  @property({ type: String }) label = '';

  render() {
    // Use vite to transform static URL
    const assetUrl = new URL('/assets/ui-core/icons/payment/skrill-1tap-icon.svg', import.meta.url).href;
    return html`
      <ui-inlined-svg class="ui-skrillonetap-icon ${this.class}" .defer=${true} .src=${assetUrl} .label=${this.label}></ui-inlined-svg>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UISkrillonetapIcon;
  }
}
